import { render } from "./HaulerTable.vue?vue&type=template&id=047906b6&scoped=true"
import script from "./HaulerTable.vue?vue&type=script&lang=js"
export * from "./HaulerTable.vue?vue&type=script&lang=js"

import "./HaulerTable.vue?vue&type=style&index=0&id=047906b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047906b6"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
